import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import formatter from "../../../../../../../../utils/formatter";
import UpArrow from "../../../../../../../../assets/icons/caret-up.png";
import DownArrow from "../../../../../../../../assets/icons/caret-down.png";
import {Triangle} from "../InvestmentTable/styles";
import { replacer, decodeName } from "../../../../../../../../utils/nameFormatter";
import { ExchangeFromTable } from './styles';
import { allocationStep3State } from "../../../../selectors";
import { replaceSelect } from "../../../../../../../../utils/replacer";

let combinedData = []; 
let lastBusinessDate = '';

function renderAvailableBalance(text) {
    const aB = combinedData.filter((pool) => {
      if (replacer(pool.investmentOption) === Object.keys(text)[0]) {
        return true;
      }
    });

    if(aB[0].availableBalance)
    return formatter({
      value: aB[0].availableBalance,
      fieldSuffix: 'Dollars',
    })
    else
    return <div>&mdash;</div>
  }

  function renderPricePerUnit(text){
    const aB = combinedData.filter((pool) => {
      if (replacer(pool.investmentOption) === Object.keys(text)[0]) {
        return true;
      }
    });
    if(aB[0].currentNav){
    return <span>{formatter({
      value: aB[0].currentNav,
      fieldSuffix: 'Dollars',
    })} <Triangle alt={(aB[0].rise === false) ? "fall" : "rise"} src={(aB[0].rise === false) ? DownArrow : UpArrow} /> </span>
  }else{
    return <div>&mdash;</div>
  }
  }

  function renderActiveExchangeUnit(text) {
    return formatter({
      value: text[Object.keys(text)[0]]["Percentage"],
      fieldSuffix: "Percentage",
    });
  }

  function renderPPUTitle() {
    return (
      <>
        <div>Price per unit</div>
        <div>as of {lastBusinessDate}</div>
      </>
    );
  }

  function renderBalanceTitle() {
    return (
      <>
        <div>Available Balance</div>
        <div>as of {lastBusinessDate}</div>
      </>
    );
  }

  function renderRowTitle(text) {
    return (
      <div>{replaceSelect(decodeName(Object.keys(text)[0]))}</div>
    );
  }

  const columns = [
    {
      title: 'Investment Options',
      render: renderRowTitle,
      key: 'name',
      width: '25%',
    },
    {
      title: renderBalanceTitle,
      render: renderAvailableBalance,
      key: 'availableBalance',
      width: '25%',
    },
    {
      title: renderPPUTitle,
      render: renderPricePerUnit,
      key: 'pricePerUnit',
      width: '25%',
    },
    {
      title: "Percentage",
      render: renderActiveExchangeUnit,
      key: 'activeExchangeUnit',
      width: '25%',
    },
  ];

  function createTableDataSource(poolData) {
    const arr = [];
    const updatedData = poolData;
    for (const pool in updatedData.portfolioBuildersForm) {
      if (Object.prototype.hasOwnProperty.call(updatedData.portfolioBuildersForm, pool)) {
        if(updatedData.portfolioBuildersForm[pool]["Percentage"] > 0 )
        arr.push({ [pool]: updatedData.portfolioBuildersForm[pool] });
      }
    }
    for (const pool in updatedData.portfolioSolutionsForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.portfolioSolutionsForm, pool)) {
          if(updatedData.portfolioSolutionsForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.portfolioSolutionsForm[pool] });
        }
    }
    for (const pool in updatedData.valueDrivenForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.valueDrivenForm, pool)) {
          if(updatedData.valueDrivenForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.valueDrivenForm[pool] });
        }
    }
   
    return arr;
  }

function Allocation(props) {
  const { poolData } = props;
  lastBusinessDate = props.lastBusinessDate;
  let updatedPoolData = props.data;
  updatedPoolData.portfolioBuilders && updatedPoolData.portfolioBuilders.map((option) => combinedData.push(option));
  updatedPoolData.portfolioSolutions && updatedPoolData.portfolioSolutions.map((option) => combinedData.push(option));
  updatedPoolData.valueDriven && updatedPoolData.valueDriven.map((option) => combinedData.push(option));

  return (
    <ExchangeFromTable
      pagination={false}
      className="w100"
      columns={columns}
      dataSource={createTableDataSource(poolData)}
      scroll={{ y: 600 }}
    />
  );
}

Allocation.propTypes = {
  data: PropTypes.object,
  poolData: PropTypes.object,
  lastBusinessDate: PropTypes.string,
}

const mapStateToProps = state => ({
  ...allocationStep3State(state.toJS())
});

export default connect(
  mapStateToProps,
  null,
)(Allocation);